import { render, staticRenderFns } from "./EditFundingScope.vue?vue&type=template&id=38e903e7&"
import script from "./EditFundingScope.vue?vue&type=script&lang=ts&"
export * from "./EditFundingScope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports